import { render, staticRenderFns } from "./EditableWithSelect.vue?vue&type=template&id=6a0b38c2&scoped=true&"
import script from "./EditableWithSelect.vue?vue&type=script&lang=ts&"
export * from "./EditableWithSelect.vue?vue&type=script&lang=ts&"
import style0 from "./EditableWithSelect.vue?vue&type=style&index=0&id=6a0b38c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b38c2",
  null
  
)

export default component.exports